import { AboutusComponent } from './components/aboutus/aboutus.component';
import { GalleryComponent } from './components/gallery/gallery.component';
import { SingleCourseSessionComponent } from './components/courses/session/session.component';
import { SingleTeacherComponent } from './components/teachers/single/single.component';
import { MainComponent } from './main.component';
import { HomeComponent } from './components/home/home.component';
import { CoursesComponent } from './components/courses/courses.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SingleCourseComponent } from './components/courses/single/single.component';
import { TeachersComponent } from './components/teachers/teachers.component';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        component: HomeComponent
      },
      {
        path: 'gallery',
        component: GalleryComponent
      },
      {
        path: 'about-us',
        component: AboutusComponent
      },
      {
        path: 'teachers/:teacherid',
        component: SingleTeacherComponent
      },
      {
        path: 'teachers',
        component: TeachersComponent
      },
      {
        path: 'courses/:courseid/lesson/:lessonid/session/:sessionid',
        component: SingleCourseSessionComponent
      },
      {
        path: 'courses/:courseid/lesson/:lessonid',
        component: SingleCourseComponent
      },
      {
        path: 'courses',
        component: CoursesComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }
